// API Configuration
// Change these values based on your environment

const API_CONFIG = {
  // Production API URL
  PRODUCTION: "https://nodejs-production-8b99.up.railway.app",

  // Development API URL (change this to your local backend URL)
  DEVELOPMENT: "http://localhost:3001",

  // Staging API URL (if you have a staging environment)
  STAGING: "https://your-staging-url.com",
};

// Get the current environment
const getEnvironment = (): keyof typeof API_CONFIG => {
  console.log("process.env.NODE_ENV", process.env);
  if (process.env.NODE_ENV === "production") {
    return "PRODUCTION";
  }
  if (process.env.NODE_ENV === "development") {
    return "DEVELOPMENT";
  }
  return "PRODUCTION"; // Default to production
};

// Export the API URL based on environment
export const API_URL =
  process.env.REACT_APP_API_URL || API_CONFIG[getEnvironment()];

// Export the config for reference
export default API_CONFIG;
